import { render, staticRenderFns } from "./QuestionList.vue?vue&type=template&id=27972b04&scoped=true"
import script from "./QuestionList.vue?vue&type=script&lang=ts"
export * from "./QuestionList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27972b04",
  null
  
)

export default component.exports